export enum FileViewTypeEnum {
  PRIVATE = 'private',
  PUBLIC = 'public'
}
export const FileViewTypeBackEndKey = 'fileViewType'
